import { Skeleton } from "@/components/ui/skeleton";

export function RouteLoading() {
  return (
    <div role="status" className="mx-auto max-w-6xl space-y-6 p-6">
      <span className="sr-only">Loading dashboard…</span>
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-4 w-64" />
      <div className="grid gap-4 sm:grid-cols-2">
        <Skeleton className="h-64" />
        <Skeleton className="h-64" />
      </div>
    </div>
  );
}
